class SalutBestsellers extends HTMLElement {
  connectedCallback() {
    this.pills = Array.from(this.querySelectorAll('.salut-pill'));
    this.list = document.getElementById(this.dataset.slider);
    this.sliderComponent = this.list ? this.list.closest('slider-component') : null;
    this.sectionId = this.dataset.section;
    this.cache = new Map();
    if (!this.list || !this.pills.length) return;

    this.cache.set(this.pills[0].dataset.collectionUrl, this.list.innerHTML);
    this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick.bind(this)));
  }

  onPillClick(event) {
    const pill = event.currentTarget;
    if (pill.classList.contains('salut-pill--active')) return;
    this.select(pill);
  }

  async select(pill) {
    const url = pill.dataset.collectionUrl;
    this.pills.forEach((item) => {
      const active = item === pill;
      item.classList.toggle('salut-pill--active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const cached = this.cache.get(url);
    if (cached !== undefined) {
      this.render(cached);
      return;
    }

    this.list.classList.add('bestsellers-salut__pills--loading');
    try {
      const response = await fetch(`${url}?section_id=${this.sectionId}`);
      if (!response.ok) throw new Error(response.status);
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const slides = parsed.querySelector('.shopify-section') || parsed.body;
      const html = slides.innerHTML.trim();
      this.cache.set(url, html);
      this.render(html);
    } catch (error) {
      console.error('Bestsellers: could not load', url, error);
    } finally {
      this.list.classList.remove('bestsellers-salut__pills--loading');
    }
  }

  render(html) {
    this.list.innerHTML = html;
    this.list.scrollTo({ left: 0, behavior: 'auto' });
    this.refreshSlider();
  }

  refreshSlider() {
    const slider = this.sliderComponent;
    if (!slider || typeof slider.initPages !== 'function') return;

    slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');
    const track = slider.querySelector('.slider-scrollbar__track');
    if (track) {
      track.dataset.numSlides = slider.sliderItems.length;
      track.style.setProperty('--num-slides', slider.sliderItems.length);
    }
    const total = slider.querySelector('.slider-counter--total');
    if (total) total.textContent = slider.sliderItems.length;

    slider.initPages();
    if (typeof slider.update === 'function') slider.update();
    if (typeof slider.sliderScrollHandler === 'function') slider.sliderScrollHandler();
  }
}

if (!customElements.get('salut-bestsellers')) {
  customElements.define('salut-bestsellers', SalutBestsellers);
}
